import {Circle as CircleStyle, Fill, Stroke, Style, Text} from "ol/style";
import * as g from "../../common/gisFuncs";
import * as f from "../../common/Funcs";

const keyName='aviary';
export default (feature, resolution) => {
    if (window.cssOn) console.debug(`${keyName} css`, feature);
    let color = [0, 0, 0, 1];
    const props = feature.getProperties();
    const source = props.source;
    let style, Point, LineString, Polygon;
        Polygon = new Style({
            stroke: new Stroke({
                color: color,
                width: (props.important&&props.type!='prepare') ? 6 : (props.type!='plan') ? 2 : 1
            }),
            text: new Text({
                text: props.label, textBaseline: 'bottom',
                fill: new Fill({color: color}),
                font: `${window.IasConfig.map.fontSize} Tahoma`,
            })
        });
        Point = new Style({
            image: new CircleStyle({radius: 5, fill: new Fill({color: color,}),}),
            text: new Text({
                text: props.label, textBaseline: 'bottom',
                fill: new Fill({color: color}),
                font: `${window.IasConfig.map.fontSize} Tahoma`,
            })
        });
        let width = 2;
    style = {
        'Point': Point,
        'Polygon': Polygon,
        'MultiPolygon': Polygon
    };
    return style[feature.getGeometry().getType()];
}
